/*
 * @Author: DESKTOP-90MI9K1\admin yangxiong
 * @Date: 2025-02-28 11:53:15
 * @LastEditors: DESKTOP-90MI9K1\admin yangxiong
 * @LastEditTime: 2025-03-19 09:42:54
 * @FilePath: \xypt-vue\src\store\modules\user.js
 * @Description: 
 * 
 * Copyright (c) 2025 by 抠脚老汉, All Rights Reserved. 
 */
import { getToken, setToken, removeToken, getCoreToken, setCoreToken, removeCoreToken, getUserName, setUserName, removeUserName, getOrgName, setOrgName, removeOrgName, getOrgNo, setOrgNo, removeOrgNo } from '@/utils/auth'
import Api from '@/api/interface/user.js'
import router from '@/router'
const state = {
  token: getToken(),
  coreToken: getCoreToken(),
  userName: getUserName(),
  orgName: getOrgName(),
  orgNo: getOrgNo(),
  avatar: '',
  httpStatus: false,
  loginShow: undefined
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_CORE_TOKEN: (state, token) => {
    state.coreToken = token
  },
  SET_USER_NAME: (state, name) => {
    state.userName = name
  },
  SET_ORG_NAME: (state, name) => {
    state.orgName = name
  },
  SET_ORG_NO: (state, no) => {
    state.orgNo = no
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_HTTPSTATUS: (state, httpStatus) => {
    state.httpStatus = httpStatus
  },
  SET_LOGIN_SHOW: (state, status) => {
    state.loginShow = status
  },
}

const actions = {
  login ({ commit }, userInfo) {
    return new Promise(async (resolve, reject) => {
      const res = await Api.loginApi(userInfo)
      const { data, code, msg, token } = res
      if (code !== 200) {
        reject(res)
        return false
      }
      commit('SET_TOKEN', token)
      setToken(token)
      resolve(res)
    })
  },
  huiCoreLogin ({ commit }) {
    return new Promise(async (resolve, reject) => {
      const res = await Api.loginCoreApi()
      const { data, code, msg, userAuthorization } = res
      if (code !== 200) {
        reject(res)
        return false
      }
      commit('SET_CORE_TOKEN', userAuthorization)
      setCoreToken(userAuthorization)
      resolve(res)
    })
  },
  userInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      Api.userInfo().then(response => {
        const { data, code } = response
        if (code !== 200) {
          reject(data, code)
          return
        }
        // commit('SET_ORG_NAME', orgName)
        // setOrgName(orgName)
        // commit('SET_ORG_NO', orgNo)
        // setOrgNo(orgNo)
        // commit('SET_USER_NAME', username)
        // setUserName(username)
        resolve(data, code)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 用户退出登录
  logout ({ commit, state }) {
    return new Promise((resolve, reject) => {
      // 清楚用户的数据
      commit('SET_TOKEN', '')
      removeToken()
      commit('SET_ORG_NAME', '')
      removeOrgName()
      commit('SET_ORG_NO', '')
      removeOrgNo()
      commit('SET_USER_NAME', '')
      removeUserName()
      localStorage.removeItem('userInfo')
      localStorage.removeItem('vipInfo')
      if (router.currentRoute.path === '/') {
        window.location.reload()
      } else {
        router.push({ path: '/' })
      }
      resolve()
    })
  },
  // token重置
  resetToken ({ commit }) {
    return new Promise(resolve => {
      return new Promise(async (resolve, reject) => {
        const res = await Api.getHuiCoreToken()
        const { data: { token }, code, msg } = res
        if (code !== 200) {
          reject(res)
          return false
        }
        commit('SET_TOKEN', token)
        setToken(token)
        resolve(res)
      })
    })
  },
  // 显示登录弹框
  loginMaskShow ({ commit }, status) {
    commit('SET_LOGIN_SHOW', status)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
